"use client";

import React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const testimonials = [{
  author: "Julian V.",
  quote: "International Experiences doesn't just book talent; they curate world-class experiences that leave our audiences breathless.",
  position: "Global Creative Director"
}, {
  author: "Elena R.",
  quote: "Working with their roster of acrobats and musicians has elevated our stage productions to a cinematic level of luxury.",
  position: "Festival Producer"
}];
export default function Testimonials() {
  return <section data-section-id="240680" id="voices-of-the-stage" className="bg-background text-foreground relative py-24 md:py-32 overflow-hidden border-t border-primary/10">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1671966/img/cinematic_stage_lighting_blur.png)] bg-cover bg-center opacity-20 blur-md scale-105" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,hsl(45,100%,58%,0.1)_0%,transparent_70%)]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto">
          <Carousel opts={{
          loop: true,
          align: "center"
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                  <div className="flex flex-col items-center text-center px-4 md:px-16 py-8">
                    <Quote className="size-12 md:size-16 text-primary/40 mb-8 md:mb-12" />
                    
                    <p className="font-serif italic text-2xl md:text-4xl lg:text-5xl leading-relaxed text-foreground mb-10 max-w-4xl tracking-wide">
                      "{testimonial.quote}"
                    </p>
                    
                    <div className="flex gap-1.5 mb-8">
                      {[...Array(5)].map((_, j) => <Star key={j} data-index={j} className="size-5 md:size-6 fill-primary text-primary drop-shadow-[0_0_8px_rgba(255,215,0,0.5)]" />)}
                    </div>
                    
                    <div className="flex flex-col items-center gap-1">
                      <h4 className="font-default font-semibold text-xl md:text-2xl tracking-widest text-foreground uppercase">
                        {testimonial.author}
                      </h4>
                      <span className="text-primary text-sm md:text-base uppercase tracking-[0.3em] font-default">
                        {testimonial.position}
                      </span>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            {}
            <div className="flex justify-center gap-6 mt-12">
              <CarouselPrevious className="static translate-y-0 translate-x-0 bg-transparent border-primary/30 text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary size-12 md:size-14 transition-all duration-500 rounded-md shadow-lg" />
              <CarouselNext className="static translate-y-0 translate-x-0 bg-transparent border-primary/30 text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary size-12 md:size-14 transition-all duration-500 rounded-md shadow-lg" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}